import { Injectable } from "@angular/core";
import { BehaviorSubject } from 'rxjs';

export class TreeItemNode {
    id : string | number;
	children: TreeItemNode[];
	label : string;
    hidden? : boolean;
	data : any;
}

/** Flat to-do item node with expandable and level information */
export class TreeItemFlatNode {
    id : string | number;
	label: string;
	level: number;
	expandable: boolean;
    hidden? : boolean;
}

/**
 * The Json object for to-do list data.
 */
const TREE_DATA = {
	Groceries: {
		'Almond Meal flour': null,
		'Organic eggs': null,
		'Protein Powder': null,
		Fruits: {
			Apple: null,
			Berries: ['Blueberry', 'Raspberry'],
			Orange: null,
		},
	},
	Reminders: ['Cook dinner', 'Read the Material Design spec', 'Upgrade Application to Angular'],
};

/**
 * Checklist database, it can build a tree structured Json object.
 * Each node in Json object represents a to-do item or a category.
 * If a node is a category, it has children items and new items can be added under the category.
 */
@Injectable()
export class ChecklistDatabase {
	dataChange = new BehaviorSubject<TreeItemNode[]>([]);

	get dataNodes(): TreeItemNode[] {
		return this.dataChange.value;
	}

	constructor() {
		this.initialize();
	}

	initialize() {		
		const data = this.buildFileTree(TREE_DATA, 0);		
		this.dataChange.next(data);
	}
	
	buildFileTree(obj: { [key: string]: any }, level: number): TreeItemNode[] {
		return Object.keys(obj).reduce<TreeItemNode[]>((accumulator, key) => {
			const value = obj[key];
			const node = new TreeItemNode();
			node.label = key;

			if (value != null) {
				if (typeof value === 'object') 
				{
					node.children = this.buildFileTree(value, level + 1);
				} 
				else 
				{
					node.label = value;
				}
			}

			return accumulator.concat(node);
		}, []);
	}
	
	insertItem(parent: TreeItemNode, name: string) 
	{
		if (parent.children) 
		{
			parent.children.push({ label : name } as TreeItemNode);
			this.dataChange.next(this.dataNodes);
		}
	}

	updateItem(node: TreeItemNode, name: string) {
		node.label = name;
		this.dataChange.next(this.dataNodes);
	}
}
